import withMetadataArgument from './withMetadataArgument.js'
import { validatePhoneNumberLength as _validatePhoneNumberLength } from '../../core/index.js'

export function validatePhoneNumberLength() {
	return withMetadataArgument(_validatePhoneNumberLength, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/validatePhoneNumberLength.js
// module id = 1172
// module chunks = 22